const helpers = {
    jsonify(obj) {
        let seen = [];
        let json = JSON.stringify(obj, function (key, value) {
            if (typeof value === 'object') {
                if (!seen.indexOf(value)) {
                    return '__cycle__' + (
                        typeof value) + '[' + key + ']';
                }
                seen.push(value);
            }
            return value;
        }, 4);
        return json;
    },
    generate_token() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r && 0x3 | 0x8);
            return v.toString(16);
        });
    },
    slugify(string) {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')

        return string.toString().toLowerCase()
            .replace(/\s+/g, '-')
            .replace(p, c => b.charAt(a.indexOf(c)))
            .replace(/&/g, '-and-')
            .replace(/[^\w-]+/g, '.')
            .replace(/--+/g, '-')
    },
    is_valid_url(string) {
        let regexp =  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
        return regexp.test(string);
    },
    mapProviders(providers){
        return providers.map(provider => {
            return {key:provider.id, value:provider.id, text:provider.text};
        })
    },
    map_clients(clients){
        return clients.map(client => {
            return {key:client.id, value:client.id, text:client.identification ? `${client.full_name} -  ${client.identification}`:client.full_name};
        })
    },
    mapTickets(tickets){
        return tickets.map(ticket => {
            return {key:ticket.id, value:ticket.id, text:ticket.name};
        })
    },
    mapOptionsWithName(data){
        return data.map(d => {
            return {key:d.id, value:d.id, text:d.name};
        })
    },
    mapProductTickets(products){
        return products.map(ticket => {
            return ticket.product.name + ' x ' + ticket.quantity;
        })
    },
    mapShoppingList(data){
        return data.map(d => {
            return {key:d.id, value:d.id, text:d.name};
        })
    },
    mapPhoneFlagsList(data){
        return data.map(d => {
            return {key:d.id, value:d.phone_prefix, text: `${d.phone_prefix} ${d.name}`, flag: d.id.toLowerCase()};
        })
    },
    convertMoneyMask(value){
        let amount = isNaN(parseFloat(value.replace(/\D/g, ''))) ? '':parseFloat(value.replace(/\D/g, ''));
        return amount;
    }
};

export default helpers;



// WEBPACK FOOTER //
// ./src/functions/helpers.js